import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
type Review = {
  quote: string;
  source: string;
};
const reviews: Review[] = [{
  quote: 'Marilyn really went out of her way to understand my needs and preferences and was with me all along to make it perfect with dozens of revisions. What I appreciate is that she is dedicated and is ready to meet instead of going back and forth. Very professional and looking to use her again and again!',
  source: 'Upwork Client'
}, {
  quote: 'She understood my vision & made it come to life. If you are in need of marketing templates or help with the aesthetic of an existing one, she\u2019s the right choice. Thanks again Marilyn',
  source: 'Upwork Client'
}, {
  quote: 'Marilyn literally saved the day for me! She helped me create and edit my presentation until it was perfect and helped me last minute troubleshoot. I gave the best speech of my life and got a standing ovation \u2014 but everyone kept asking for the slides! It\u2019s easy to come on here and just get templates, but Marilyn went above and beyond.',
  source: 'Upwork Client'
}];
export function Testimonials() {
  return <section id="reviews" className="py-24 md:py-32 bg-cream" data-id="element-177">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-178">
        <div className="flex flex-col md:flex-row md:justify-between md:items-end mb-16 md:mb-24 gap-6" data-id="element-179">
          <h2 className="text-5xl md:text-7xl font-serif tracking-tight" data-id="element-180">
            Client <span className="italic text-ink-light" data-id="element-181">Words</span>
          </h2>
          <div className="flex items-center gap-2" data-id="element-182">
            <div className="flex gap-0.5 text-accent" data-id="element-183">
              {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" strokeWidth={0} data-id="element-184" />)}
            </div>
            <span className="text-ink-light text-sm font-medium" data-id="element-185">
              5.0 average on Upwork
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-186">
          {reviews.map((review, index) => <motion.figure key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7,
          ease: [0.76, 0, 0.24, 1],
          delay: index * 0.12
        }} className="flex flex-col justify-between border border-ink/10 rounded-lg p-8 bg-cream-dark/30" data-id="element-187">
              <div data-id="element-188">
                <div className="flex gap-0.5 text-accent mb-6" data-id="element-189">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" strokeWidth={0} data-id="element-190" />)}
                </div>
                <blockquote className="text-ink-light leading-relaxed" data-id="element-191">
                  &ldquo;{review.quote}&rdquo;
                </blockquote>
              </div>
              <figcaption className="mt-8 pt-6 border-t border-ink/10 text-sm font-medium text-ink" data-id="element-192">
                {review.source}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}